import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

const PWD_PATTERN = /^[A-Za-z0-9!#$%&@]{8,64}$/;
const PWD_FORMAT_MESSAGE = '入力条件は8文字以上64文字以内で入力してください。半角英数字と記号 ! # $ % & @ が使用可能です。';

@Component({
    components: {}
})
export default class PwdRegisterModal extends Vue {

    @Prop()
    isPwdRegisterModal!: boolean

    private password: string | null = null;
    private confirmPassword: string | null = null;
    private showPassword = false;
    private isLoading = false;

    @Watch('isPwdRegisterModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
        if (!val) {
            this.resetForm();
        }
    }

    submit(): void {
        if (this.isLoading) {
            return;
        }
        if (!PWD_PATTERN.test(this.password ?? '')) {
            window.alert(PWD_FORMAT_MESSAGE);
            return;
        }
        if (this.password !== this.confirmPassword) {
            window.alert('パスワードが一致しません。');
            return;
        }
        this.isLoading = true;
        this.$apiClient.doRequest('put', '/pwd_settings', {
            password: this.password,
            confirmPassword: this.confirmPassword
        }).then(() => {
            this.resetForm();
            this.$toasted.success('パスワードを設定しました。');
            this.$emit('registered');
            this.$emit('update:isPwdRegisterModal', false);
        }).finally(() => {
            this.isLoading = false;
        });
    }

    closeModal(): void {
        this.resetForm();
        this.$emit('update:isPwdRegisterModal', false);
    }

    private resetForm(): void {
        this.password = null;
        this.confirmPassword = null;
        this.showPassword = false;
    }
}
